import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { ChartTooltip } from './ChartTooltip';

export const TrendAreaChart = ({ data = [], series = [], height = 300, xKey = 'period', formatY, formatTip, xTickFormatter }) => {
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%" minWidth={0}>
        <AreaChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -8 }}>
          <defs>
            {series.map((s) => (
              <linearGradient key={s.key} id={`grad-${s.key}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={s.color} stopOpacity={0.18} />
                <stop offset="100%" stopColor={s.color} stopOpacity={0.02} />
              </linearGradient>
            ))}
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(11,19,32,0.06)" vertical={false} />
          <XAxis dataKey={xKey} tickLine={false} axisLine={false} tickFormatter={xTickFormatter} minTickGap={24} />
          <YAxis tickLine={false} axisLine={false} width={44} tickFormatter={formatY} />
          <Tooltip content={<ChartTooltip formatter={formatTip} />} />
          {series.length > 1 && <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />}
          {series.map((s) => (
            <Area key={s.key} type="monotone" dataKey={s.key} name={s.name} stroke={s.color}
                  strokeWidth={2.25} fill={`url(#grad-${s.key})`} dot={false} activeDot={{ r: 4 }} />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
